import { SeatsioEventManager, SeatsioDesigner } from '@seatsio/seatsio-react'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { fetchSeatsIoData } from '../../../../../_common/core/http_services'
import Card from '../../../../_library/Card'
import Modal from 'react-modal'
import modalStyle from '../../../../../_common/core/modalStyle'
import Button from '../../../../_library/Button'
import { SeatsIoTicketManager } from './SeatsIoTicketManager'
import { showAxiosError, showSuccessMessage } from '../../../../utils/messenger'
import { SeatsIoMapManager } from './SeatsIoMapManager'
import {
  createChart, createSeasonEvent,
  createTag,
  deleteMap,
  fetchSeatsIoConfiguration,
  fetchSeatsIoEvent,
  fetchSeatsIoMapsByVenue,
  setSeatsIoData,
} from '../../../../../_common/core/http_services/seatsio'
import { OverlayTrigger } from '../../../../_library/OverlayTrigger'
import { getTableColumns } from '../../../../utils/sortableTableUtils'
import SortableTable from '../../../../_library/SortableTable'
import Field from '../../../../_library/Field'
import { Form, Formik } from 'formik'
import Select from '../../../../_library/Select'
import ConfirmModal from '../../../../_library/ConfirmModal'
import { ROLES } from '../../../../constants/roles'
import { SeatsIoSeasonEventPicker } from './SeatsIoSeasonEventPicker'
import { SeatsIoSeasonEventsManager } from './SeatsIoSeasonEventsManager'

export const SeatsIoEventManager = ({
  eventId,
  venueId,
  tickets,
  user,
  tables,
  hasSales,
  flagShowSeatsIoMapsByVenue,
}) => {
  const [data, setData] = useState(null)
  const [activeData, setActiveData] = useState(null)
  const [activeEventId, setActiveEventId] = useState('main')
  const [venueData, setVenueData] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [showModalStatus, setShowModalStatus] = useState(false)
  const [showModalTickets, setShowModalTickets] = useState(false)
  const [showModalAttachEvent, setShowModalAttachEvent] = useState(false)
  const [showModalEditEvent, setShowModalEditEvent] = useState(false)
  const [showModalCreateMap, setShowModalCreateMap] = useState(false)
  const [seatsIoNewChart, setSeatsIoNewChart] = useState(null)
  const [isCreating, setIsCreating] = useState(false)
  const [configuration, setConfiguration] = useState(false)
  const [showMapsByVenue, setShowMapsByVenue] = useState(false)
  const [dataEvent, setDataEvent] = useState(null)
  const [showDeleteMap, setShowDeleteMap] = useState(false)
  const [showSeasonEventsManager, setShowSeasonEventsManager] = useState(false)
  useEffect(() => {
    const seatsIoData = async () => {
      const response = await fetchSeatsIoEvent(eventId)
      setDataEvent(response)
    }
    seatsIoData()
  }, [eventId])
  const fetchSeatData = useCallback(async (currentEventId, selectedSeatsIoEventId) => {
    try {
      const response = await fetchSeatsIoData(eventId, selectedSeatsIoEventId)
      if (selectedSeatsIoEventId === 'main' || !selectedSeatsIoEventId) {
        setData(response)
      }
      setActiveData(response)
      setActiveEventId(selectedSeatsIoEventId ?? 'main')
    } catch {}
    try {
      if (venueId) {
        const responseVenue = await fetchSeatsIoMapsByVenue(venueId)
        setVenueData(responseVenue)
      }
    } catch {}
  }, [eventId, venueId])
  useEffect(() => {
    if (eventId) {
      fetchSeatData(eventId)
    }
  }, [eventId, fetchSeatData])
  useEffect(() => {
    const getConfiguration = async () => {
      try {
        const configuration = await fetchSeatsIoConfiguration()
        setConfiguration(configuration)
      } catch {}
    }
    getConfiguration()
  }, [])
  const tableColumns = useRef(
    getTableColumns([
      {
        label: 'Image',
        key: 'thumbnailUrl',
        normalizer: data => <img height={100} src={data} alt="" />,
      },
      {
        label: 'Name',
        key: 'chartName',
      },
    ]),
  )
  return (
    <Card title={'Configure seat.io Map'}>
      <div>
        <div style={{ width: 'inherit', margin: 0 }} className={'form-group'}>
          {data ? (
            <>
              <OverlayTrigger
                hideTooltip={!!(tickets?.length || tables?.length)}
                placement="top"
                id="issueTicketsButtonTooltip"
                tooltip={<span>Please create tickets for this event</span>}
                delayShow={400}
                delayHide={10}
                className={'display-inline-block'}
              >
                <div className="display-inline-block display-inline-block-button-container">
                  <Button
                    type="button"
                    className="btn btn-lightpurple btn-shadow"
                    onClick={() => setShowModalTickets(true)}
                    disabled={!(tickets?.length || tables?.length)}
                    style={{ pointerEvent: tickets?.length || tables?.length ? 'auto' : 'none' }}
                  >
                    Configure Tickets
                  </Button>
                </div>
              </OverlayTrigger>
              {user?.tfStaff || (user?.clientRoles?.editMapRole ?? false) ? (
                <OverlayTrigger
                  hideTooltip={!!dataEvent}
                  placement="top"
                  id="issueTicketsButtonTooltip"
                  tooltip={<span>Please ask to add the correct label to the chart</span>}
                  delayShow={400}
                  delayHide={10}
                  className={'display-inline-block'}
                >
                  <div className="display-inline-block display-inline-block-button-container">
                    <Button
                      type="button"
                      className="btn btn-lightpurple btn-shadow"
                      onClick={() => setShowModalEditEvent(true)}
                      disabled={!dataEvent}
                      style={{ pointerEvent: venueData?.length ? 'auto' : 'none' }}
                    >
                      {data && data?.type === 'season' ? 'Edit Seat Maps Chart' : 'Edit Map'}
                    </Button>
                  </div>
                </OverlayTrigger>
              ) : null}
              {[
                ROLES.TTF_TEAM,
                ROLES.TF_DEVELOPER,
                ROLES.TF_SUPPORT,
                ROLES.TF_SUPPORT_ADMIN,
                ROLES.TF_CLIENT_SUPPORT,
                ROLES.TF_CLIENT_SUPPORT_ADMIN,
              ].includes(user?.tfRole) || user?.isSuperAdmin ? (
                <OverlayTrigger
                  hideTooltip={!hasSales}
                  placement="top"
                  id="issueTicketsButtonTooltip"
                  tooltip={
                    <span>
                      {data && data?.type === 'season'
                        ? 'Seat maps cannot be deleted once ticket sales have started'
                        : 'Map cannot be deleted once ticket sales have started'}
                    </span>
                  }
                  delayShow={400}
                  delayHide={10}
                  className={'display-inline-block'}
                >
                  <div>
                    <Button
                      type="button"
                      className="btn btn-lightpurple btn-shadow"
                      onClick={() => setShowDeleteMap(true)}
                      disabled={hasSales}
                      style={{ margin: 5 }}
                    >
                      {data && data?.type === 'season' ? 'Delete All Seat Maps' : 'Delete map'}
                    </Button>
                  </div>
                </OverlayTrigger>
              ) : null}
              <Button
                type="button"
                className="btn btn-primary btn-shadow"
                style={{ margin: 5 }}
                onClick={() => setShowModal(true)}
              >
                Manage Seats Blocking
              </Button>
              <Button
                type="button"
                className="btn btn-seablue btn-shadow"
                style={{ margin: 5 }}
                onClick={() => setShowModalStatus(true)}
              >
                Manage Seats Status
              </Button>
              {data?.type === 'season' && (
                <Button
                  type="button"
                  className="btn btn-seablue btn-shadow"
                  style={{ margin: 5 }}
                  onClick={() => setShowSeasonEventsManager(true)}
                >
                  Manage seat maps
                </Button>
              )}
            </>
          ) : (
            <>
              <OverlayTrigger
                hideTooltip={!!(tickets?.length || tables?.length)}
                placement="top"
                id="issueTicketsButtonTooltip"
                tooltip={<span>Please create tickets for this event</span>}
                delayShow={400}
                delayHide={10}
                className={'display-inline-block'}
              >
                <div className="display-inline-block display-inline-block-button-container">
                  <Button
                    className={'btn btn-seablue btn-shadow'}
                    type="button"
                    disabled={!(tickets?.length || tables?.length)}
                    onClick={() => setShowModalAttachEvent(true)}
                    style={{ pointerEvent: tickets?.length || tables?.length ? 'auto' : 'none' }}
                  >
                    Configure Seat.io Event
                  </Button>
                </div>
              </OverlayTrigger>
              {[
                ROLES.TF_DEVELOPER,
                ROLES.TF_SUPPORT,
                ROLES.TF_SUPPORT_ADMIN,
                ROLES.TF_CLIENT_SUPPORT,
                ROLES.TF_CLIENT_SUPPORT_ADMIN,
              ].includes(user?.tfRole) || user?.isSuperAdmin ? (
                <Button
                  type="button"
                  className="btn btn-lightpurple btn-shadow"
                  onClick={() => setShowModalCreateMap(true)}
                  loading={!configuration}
                >
                  Create map
                </Button>
              ) : null}
              {flagShowSeatsIoMapsByVenue &&
              ([
                ROLES.TF_DEVELOPER,
                ROLES.TF_SUPPORT,
                ROLES.TF_SUPPORT_ADMIN,
                ROLES.TF_CLIENT_SUPPORT,
                ROLES.TF_CLIENT_SUPPORT_ADMIN,
              ].includes(user?.tfRole) ||
                user?.isSuperAdmin) ? (
                <OverlayTrigger
                  hideTooltip={!!tickets?.length}
                  placement="top"
                  id="issueTicketsButtonTooltip"
                  tooltip={<span>Please create tickets for this event</span>}
                  delayShow={400}
                  delayHide={10}
                  className={'display-inline-block'}
                >
                  <div className="display-inline-block display-inline-block-button-container">
                    <Button
                      type="button"
                      className="btn btn-lightpurple btn-shadow"
                      style={{ pointerEvent: tickets?.length ? 'auto' : 'none' }}
                      onClick={() => setShowMapsByVenue(true)}
                      loading={!configuration}
                      disabled={!tickets?.length}
                    >
                      Select available maps by venue
                    </Button>
                  </div>
                </OverlayTrigger>
              ) : null}
            </>
          )}
        </div>
      </div>
      {data && activeData ? (
        <>
          <ConfirmModal
            isOpen={showDeleteMap}
            header={'Confirm Delete'}
            content={'Are you sure you want to delete the seats io map from this event?'}
            actions={[
              { value: 'ok', label: 'Ok', className: 'btn btn-success btn-shadow' },
              { value: 'cancel', label: 'Cancel', className: 'btn btn-default' },
            ]}
            onAction={async response => {
              switch (response) {
                case 'ok': {
                  try {
                    await deleteMap(eventId)
                    showSuccessMessage('Map deleted succesfully!')
                    setData(null)
                    setDataEvent(null)
                  } catch (e) {
                    showAxiosError(e)
                  } finally {
                    setShowDeleteMap(false)
                  }
                  break
                }
                default: {
                  setShowDeleteMap(false)
                  break
                }
              }
            }}
          />
          <Modal
            className="modal-dialog modal-trans p7"
            style={modalStyle}
            isOpen={showModal}
            ariaHideApp={false}
            contentLabel="Modal"
            onRequestClose={() => setShowModal(false)}
            closeTimeoutMS={10}
          >
            <div style={{ backgroundColor: '#292d32', justifyContent: 'center', textAlign: 'center' }}>
              <div className="modal-header">
                <p className="h4 text-compact">Manage Seats Blocking</p>
              </div>
              <div className="seatsio-manager">
                <SeatsioEventManager
                  secretKey={activeData.workplace_secret_key}
                  event={activeData.event_id}
                  mode="manageForSaleConfig"
                  region={activeData.region}
                />
              </div>
              <div className="modal-footer">
                <div className="btn-toolbar">
                  {data?.type === 'season' && (
                    <>
                      <label>You&apos;re currently seeing seat statuses for seat map: </label>
                      <SeatsIoSeasonEventPicker
                        seasonData={data}
                        preselectedSeatsIoId={activeEventId ?? 'main'}
                        onEventChange={selectedEventId => {
                          fetchSeatData(eventId, selectedEventId)
                        }}
                      />
                    </>
                  )}
                  <Button
                    type="button"
                    className="btn btn-cancel btn-shadow"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
          <Modal
            className="modal-dialog modal-trans p7"
            style={modalStyle}
            isOpen={showModalStatus}
            ariaHideApp={false}
            contentLabel="Modal"
            onRequestClose={() => setShowModalStatus(false)}
            closeTimeoutMS={10}
          >
            <div style={{ backgroundColor: '#292d32', justifyContent: 'center', textAlign: 'center' }}>
              <div className="modal-header">
                <p className="h4 text-compact">Manage Seats Status</p>
              </div>
              <div className="seatsio-manager">
                <SeatsioEventManager
                  secretKey={activeData.workplace_secret_key}
                  event={activeData.event_id}
                  mode="manageObjectStatuses"
                  region={activeData.region}
                />
              </div>
              <div className="modal-footer">
                <div className="btn-toolbar">
                  {data?.type === 'season' && (
                    <>
                      <label>You&apos;re currently seeing seat statuses for seat map: </label>
                      <SeatsIoSeasonEventPicker
                        seasonData={data}
                        preselectedSeatsIoId={activeEventId ?? 'main'}
                        onEventChange={selectedEventId => {
                          fetchSeatData(eventId, selectedEventId)
                        }}
                      />
                    </>
                  )}
                  <Button
                    type="button"
                    className="btn btn-cancel btn-shadow"
                    onClick={() => setShowModalStatus(false)}
                  >
                    Close
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
          <Modal
            className="modal-dialog modal-trans p5"
            style={modalStyle}
            isOpen={showModalTickets}
            ariaHideApp={false}
            contentLabel="Modal"
            onRequestClose={() => setShowModalTickets(false)}
            closeTimeoutMS={10}
          >
            <div style={{ backgroundColor: '#292d32', justifyContent: 'center', textAlign: 'center' }}>
              <div className="modal-header">
                <p className="h4 text-compact">Configure Tickets</p>
              </div>
              <SeatsIoTicketManager
                eventId={eventId}
                tickets={tickets}
                tables={tables}
                eventData={data}
                activeEventData={activeData}
                currentEventId={activeEventId ?? 'main'}
                fetchSeatData={fetchSeatData}
              />
              <div className="modal-footer">
                <div className="btn-toolbar">
                  <Button
                    type="button"
                    className="btn btn-cancel btn-shadow"
                    onClick={() => setShowModalTickets(false)}
                  >
                    Close
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
          {dataEvent ? (
            <Modal
              className="modal-dialog modal-trans seatsio-modal"
              style={modalStyle}
              isOpen={showModalEditEvent}
              ariaHideApp={false}
              contentLabel="Modal"
              onRequestClose={() => setShowModalEditEvent(false)}
              closeTimeoutMS={10}
            >
              <div
                className="seatsio-modal-container"
                style={{ backgroundColor: '#292d32', justifyContent: 'center', textAlign: 'center' }}
              >
                <div className="modal-header">
                  <p className="h4 text-compact">
                    {data && data?.type === 'season' ? 'Edit Seat Maps Chart' : 'Edit Map'}
                  </p>
                </div>
                <div className="modal-body">
                  <p>
                    If you have modified seats for sold tickets, issue guest tickets to accommodate the same
                    customers
                  </p>
                </div>
                <div className="seatsio-manager">
                  <SeatsioDesigner
                    secretKey={data.workplace_secret_key}
                    chartKey={dataEvent.seatsIoChartKey}
                    region={data.region}
                    features={{
                      readOnly: ['chartName'],
                      disabled: [],
                    }}
                    mode="normal"
                    openLatestDrawing
                  />
                </div>
                <div className="modal-footer">
                  <div className="btn-toolbar">
                    <Button
                      type="button"
                      className="btn btn-cancel btn-shadow"
                      onClick={() => setShowModalEditEvent(false)}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </div>
            </Modal>
          ) : null}
        </>
      ) : null}
      {venueData ? (
        <Modal
          className="modal-dialog modal-trans p5"
          style={modalStyle}
          isOpen={showMapsByVenue}
          ariaHideApp={false}
          contentLabel="Modal"
          onRequestClose={() => setShowMapsByVenue(false)}
          closeTimeoutMS={10}
        >
          <div style={{ backgroundColor: '#292d32', justifyContent: 'center', textAlign: 'center' }}>
            <div className="modal-header">
              <p className="h4 text-compact">Select Available Maps by Venue</p>
            </div>
            <div style={{ margin: 10 }}>
              <SortableTable
                data={venueData}
                tableColumns={tableColumns.current}
                enableSort={false}
                enableCopyTable={false}
                disableMobileView={true}
                className="child-table"
                actionsLabel="Actions"
                actions={[
                  {
                    label: 'Use Map',
                    className: 'btn btn-primary',
                    onClick: async data => {
                      try {
                        await setSeatsIoData({
                          eventId,
                          chartKey: data.chartKey,
                          chartName: data.chartName,
                        })
                        setShowMapsByVenue(false)
                        showSuccessMessage('Event linked successfully!')
                        await fetchSeatData(eventId)
                        const response = await fetchSeatsIoEvent(eventId)
                        setDataEvent(response)
                      } catch (e) {
                        showAxiosError(e)
                      }
                    },
                  },
                ]}
              />
            </div>
            <div className="modal-footer">
              <div className="btn-toolbar">
                <Button
                  type="button"
                  className="btn btn-cancel btn-shadow"
                  onClick={() => setShowMapsByVenue(false)}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      ) : null}
      <Modal
        className="modal-dialog modal-trans p5"
        style={modalStyle}
        isOpen={showModalAttachEvent}
        ariaHideApp={false}
        contentLabel="Modal"
        onRequestClose={() => setShowModalAttachEvent(false)}
        closeTimeoutMS={10}
      >
        <div style={{ backgroundColor: '#292d32', justifyContent: 'center', textAlign: 'center' }}>
          <div className="modal-header">
            <p className="h4 text-compact">Configure Seat.io Event</p>
          </div>
          <SeatsIoMapManager
            eventId={eventId}
            data={data}
            fetchSeatData={fetchSeatData}
            setShowModalAttachEvent={setShowModalAttachEvent}
          />
          <div className="modal-footer">
            <div className="btn-toolbar">
              <Button
                type="button"
                className="btn btn-cancel btn-shadow"
                onClick={() => setShowModalAttachEvent(false)}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      {configuration ? (
        <Modal
          className={
            !seatsIoNewChart ? 'modal-dialog modal-trans p5' : 'modal-dialog modal-trans seatsio-modal'
          }
          style={modalStyle}
          isOpen={showModalCreateMap}
          ariaHideApp={false}
          contentLabel="Modal"
          closeTimeoutMS={10}
        >
          <div
            className="seatsio-modal-container"
            style={{ backgroundColor: '#292d32', justifyContent: 'center', textAlign: 'center' }}
          >
            <div className="modal-header">
              <p className="h4 text-compact">Create Map</p>
            </div>
            {!seatsIoNewChart ? (
              <Formik
                initialValues={{
                  name: '',
                  venueType: 'MIXED',
                  eventType: 'event',
                  eventName: null,
                }}
                validate={values => {
                  const errors = {}
                  if (!values.name) {
                    errors.chartKey = 'Required'
                  }
                  return errors
                }}
                onSubmit={async values => {
                  try {
                    setIsCreating(true)
                    const data = await createChart({
                      data: {
                        attributes: {
                          name: values.name,
                          venueType: values.venueType,
                          categories: [],
                        },
                      },
                    })
                    await createTag(data.key, 'venue:' + venueId)
                    setSeatsIoNewChart({
                      name: data.name,
                      key: data.key,
                      eventName: values.eventName,
                      type: values.eventType,
                    })
                    showSuccessMessage('Event map created successfully!')
                  } catch (e) {
                    showAxiosError(e?.message)
                  } finally {
                    setIsCreating(false)
                  }
                }}
              >
                {({ values, errors, touched, handleChange, handleBlur, isSubmitting, setFieldValue }) => {
                  const onTemplateTypeChange = e => {
                    setFieldValue('venueType', e.target.value)
                  }
                  const isSeason = values.eventType
                  return (
                    <Form>
                      <div className="col-xs-6 col-12">
                        <Field
                          id="name"
                          label="Chart Name"
                          value={values.name}
                          error={errors.name}
                          touched={touched.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div>
                      <div className="col-xs-6 col-12">
                        <Select
                          id="venueType"
                          label="Venue Type"
                          options={[
                            { value: 'MIXED', label: 'Chart Without Sections' },
                            { value: 'ROWS_WITH_SECTIONS', label: 'Chart With Sections' },
                          ]}
                          value={values.venueType}
                          error={errors.venueType}
                          touched={touched.venueType}
                          onChange={onTemplateTypeChange}
                          onBlur={handleBlur}
                        />
                      </div>
                      <div className="col-xs-6 col-12">
                        <Select
                          id="eventType"
                          label="Event type"
                          options={[
                            { value: 'event', label: 'Single day event' },
                            { value: 'season', label: 'Multi day event' },
                          ]}
                          value={values.eventType}
                          error={errors.eventType}
                          touched={touched.eventType}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div>
                      {isSeason === 'season' && (
                        <div className="col-xs-6 col-12">
                          <Field
                            id="eventName"
                            label="Name of the main seat map"
                            value={values.eventName ?? ''}
                            error={errors.eventName}
                            touched={touched.eventName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <small>This seat map is able to book across all days of your event</small>
                        </div>
                      )}
                      <div className="div-spacing-20" />
                      <div className="modal-footer">
                        <div className="btn-toolbar">
                          <Button
                            type="button"
                            className="btn btn-cancel btn-shadow"
                            onClick={() => {
                              setShowModalCreateMap(false)
                            }}
                          >
                            Close
                          </Button>
                          <Button
                            type="submit"
                            className="btn btn-primary btn-shadow"
                            disabled={isCreating}
                            loading={isCreating}
                          >
                            Save
                          </Button>
                        </div>
                      </div>
                    </Form>
                  )
                }}
              </Formik>
            ) : (
              <>
                <div className="seatsio-manager">
                  <SeatsioDesigner
                    secretKey={configuration.workplace_secret_key}
                    region={configuration.region}
                    chartKey={seatsIoNewChart.key}
                    features={{
                      readOnly: ['chartName'],
                    }}
                  />
                </div>
                <div className="modal-footer">
                  <div className="btn-toolbar">
                    <Button
                      type="button"
                      className="btn btn-cancel btn-shadow"
                      onClick={() => {
                        setShowModalCreateMap(false)
                      }}
                    >
                      Close
                    </Button>
                    <Button
                      type="button"
                      className="btn btn-primary btn-shadow"
                      disabled={isCreating}
                      loading={isCreating}
                      onClick={async () => {
                        try {
                          setIsCreating(true)
                          await setSeatsIoData({
                            eventId,
                            chartKey: seatsIoNewChart.key,
                            chartName: seatsIoNewChart.name,
                            name: seatsIoNewChart.eventName,
                            type: seatsIoNewChart.type,
                          })
                          setShowModalCreateMap(false)
                          setIsCreating(false)
                          setSeatsIoNewChart(null)
                          showSuccessMessage('Event linked successfully!')
                          await fetchSeatData(eventId)
                          const response = await fetchSeatsIoEvent(eventId)
                          setDataEvent(response)
                        } catch (e) {
                          setIsCreating(false)
                          showAxiosError({}, 'Please solve all issues listed in the Editor')
                        }
                      }}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </>
            )}
          </div>
        </Modal>
      ) : null}
      {data?.type === 'season' && (
        <SeatsIoSeasonEventsManager
          isOpen={showSeasonEventsManager}
          onClose={() => setShowSeasonEventsManager(false)}
          seasonData={data}
          eventId={eventId}
          onEventsUpdated={() => fetchSeatData(eventId)}
          hasSales={hasSales}
        />
      )}
    </Card>
  )
}
